import { motion } from "framer-motion";
import { Shield, Star, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { RAFFLE } from "@/lib/raffleData";

const NAV = [
  { label: "Entregas", href: "#premios" },
  { label: "Ficha", href: "#ficha" },
  { label: "Sorteo", href: "#sorteo" },
  { label: "Cómo participar", href: "#como" },
  { label: "Contacto", href: "#contacto" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#051A0F]/90 backdrop-blur-xl border-b border-[#F0B91B]/20 py-3"
          : "bg-transparent py-5"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link">
          <div className="relative w-11 h-11 group-hover:scale-105 transition-transform">
            <Shield
              className="w-11 h-11 text-[#0A4A26] drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]"
              fill="#0A4A26"
              strokeWidth={1.5}
              stroke="#F0B91B"
            />
            <Star
              className="w-5 h-5 text-[#F0B91B] fill-[#F0B91B] absolute inset-0 m-auto"
              strokeWidth={1.5}
              style={{ top: "-2px" }}
            />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-bebas text-2xl text-[#FDFBF7] tracking-widest">
              {RAFFLE.brand}
            </span>
            <span className="text-[9px] uppercase tracking-[0.3em] text-[#F0B91B] font-outfit font-semibold">
              Gran Proyecto
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-[#FDFBF7]/80 hover:text-[#F0B91B] transition-colors uppercase tracking-wider font-outfit font-medium relative group"
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-").replace("ó", "o")}`}
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[#F0B91B] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="#elegir-ficha"
          className="hidden md:inline-flex items-center gap-2 bg-[#F0B91B] hover:bg-[#FFD700] text-[#051A0F] px-5 py-2.5 rounded-full font-bebas text-lg tracking-wider shadow-[0_8px_24px_-8px_rgba(240,185,27,0.6)] hover:shadow-[0_12px_32px_-6px_rgba(240,185,27,0.8)] transition-all hover:-translate-y-0.5"
          data-testid="header-cta-buy"
        >
          Adquirir Ficha
        </a>

        <button
          className="md:hidden text-[#F0B91B]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-[#051A0F]/98 backdrop-blur-xl border-t border-[#F0B91B]/20 mt-3"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-[#FDFBF7]/90 hover:text-[#F0B91B] font-bebas text-2xl tracking-wider"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#elegir-ficha"
              onClick={() => setOpen(false)}
              className="mt-2 bg-[#F0B91B] text-[#051A0F] px-5 py-3 rounded-full font-bebas text-xl tracking-wider text-center"
              data-testid="mobile-cta-buy"
            >
              Adquirir Ficha
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
